export default __webpack_public_path__ + "static/media/ben-and-harley.044a8d4b.jpg";